import request from '@/utils/request'


// 查询动态推广时长模板列表
export function listPopularizeTemplate(query) {
  return request({
    url: '/popularize/popularize/list',
    method: 'get',
    params: query
  })
}

// 查询动态推广时长模板分页
export function pagePopularize(query) {
  return request({
    url: '/popularize/popularize/page',
    method: 'get',
    params: query
  })
}

// 查询动态推广时长模板详细
export function getPopularize(data) {
  return request({
    url: '/popularize/popularize/detail',
    method: 'get',
    params: data
  })
}

// 新增动态推广时长模板
export function addPopularize(data) {
  return request({
    url: '/popularize/popularize/add',
    method: 'post',
    data: data
  })
}

// 修改动态推广时长模板
export function updatePopularize(data) {
  return request({
    url: '/popularize/popularize/edit',
    method: 'post',
    data: data
  })
}

// 删除动态推广时长模板
export function delPopularize(data) {
  return request({
    url: '/popularize/popularize/delete',
    method: 'post',
    data: data
  })
}
